// Fashion layout: product carousel arrows and colour thumbnails on product cards.

class FsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.fs-carousel__track');
    this.prev = this.querySelector('[data-dir="-1"]');
    this.next = this.querySelector('[data-dir="1"]');
    if (!this.track) return;

    this.querySelectorAll('.fs-carousel__nav').forEach((button) =>
      button.addEventListener('click', () => {
        const slide = this.track.querySelector('.fs-carousel__slide');
        const step = slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 300;
        this.track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
      })
    );
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());
    this.update();
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
  }
}
if (!customElements.get('fs-carousel')) customElements.define('fs-carousel', FsCarousel);

// Clicking a colour thumbnail shows that colour's photo and links the card to that variant.
document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.fs-card__swatch');
  if (!swatch) return;
  const card = swatch.closest('.fs-card');
  const image = card.querySelector('.fs-card__img--primary');
  if (swatch.dataset.src && image) {
    image.removeAttribute('srcset');
    image.src = swatch.dataset.src;
  }
  if (swatch.dataset.url) {
    card.querySelectorAll('.fs-card__media, .fs-card__title').forEach((link) => link.setAttribute('href', swatch.dataset.url));
  }
  card.querySelectorAll('.fs-card__swatch').forEach((item) => item.classList.toggle('is-active', item === swatch));
});
